export const REG_GROUP = {
    number: "0-9",
    ko: "ㄱ-ㅎ|ㅏ-ㅣ|가-힣|ㆍᆢ",
    en: "a-zA-Z",
    spec: "~!@#$%;:^&*\\(\\)-=_+{}\\[\\]<>,./?'\"",
    space: "\\s"
};
